import { useEffect } from 'preact/hooks';
import { signal } from '@preact/signals';
import { T } from '../styles/tokens';
import { Button } from '../components/ui';
import { useTranslation } from 'react-i18next';

const countdown = signal(5);

export function SubscriptionSuccessPage() {
  const { t } = useTranslation('billing');
  useEffect(() => {
    const timer = setInterval(() => {
      countdown.value -= 1;
      if (countdown.value <= 0) {
        clearInterval(timer);
        window.location.href = '/profile?tab=plano';
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', textAlign: 'center', padding: 40,
    }}>
      <div style={{ fontSize: '4rem', marginBottom: 20 }}></div>
      <h1 style={{ color: T.text, fontSize: '2rem', fontWeight: 800, marginBottom: 12 }}>
        {t('subscription_activated')}
      </h1>
      <p style={{ color: T.textSecondary, fontSize: '1.1rem', marginBottom: 24 }}>
        {t('plan_now_active')}
      </p>
      <p style={{ color: T.textMuted, fontSize: '0.9rem' }}>
        {t('redirecting', { seconds: countdown.value })}
      </p>
      <Button variant="ghost"
        onClick={() => { window.location.href = '/profile?tab=plano'; }}
        style={{
          marginTop: 20, padding: '12px 32px', borderRadius: 10, border: 'none',
          background: T.success, color: T.text, fontWeight: 700, cursor: 'pointer',
        }}
      >
        {t('go_to_profile')}
      </Button>
    </div>
  );
}
